/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { object } from 'prop-types';
import ReactMarkdown from 'react-markdown';

const useStyles = makeStyles(() => ({
    holidayBannerRoot: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '12px 10px',
        margin: '10px 0px ',
        borderRadius: '6px',
        width: '95%',
        height: '50px',
        '@media(min-width: 600px)': {
            margin: '10px 50px 0px',
            width: '81%',
            height: '50px',
        },
    },
    messageBody: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        color: '#000000',
        display: 'flex',
    },
    copy: {
        textAlign: 'center',
        color: '#000000',
        '& p': {
            margin: 0,
            width: '370px',
            '@media(max-width: 531px)': {
                width: '300px',
            },
            '@media(max-width: 431px)': {
                width: '250px',
            },
            '@media(max-width: 375px)': {
                fontSize: '12px',
                width: '200px',
            },
            '@media(max-width: 321px)': {
                fontSize: '12px',
                width: '180px',
            },
        },
    },
    iconLeft: {
        marginRight: '6px',
    },
    iconRight: {
        marginLeft: '6px',
    },
    holidayIconLeft: {
        margin: 'auto',
        paddingRight: '8px',
    },
    holidayIconRight: {
        margin: 'auto',
        paddingLeft: '8px',
    },
}));

const CalendarBanner = ({ bannerData }) => {
    const classes = useStyles();
    // there is css implemented(maybe in CS) conflicting with div, using section for now.
    return (
        <section style={{ background: bannerData.flexBannerHoliday.banner?.background_color?.color || bannerData.flexBannerHoliday?.banner?.background?.color  || 'transparent' }} className={classes.holidayBannerRoot}>
            <section className={classes.messageBody}>
                <span className={classes.holidayIconLeft}>
                    <img src={bannerData.bannerIcon} alt="holiday_banner_left" />
                </span>
                <ReactMarkdown className={classes.copy} source={bannerData.flexBannerHoliday?.banner?.copy} escapeHtml={false} />
                <span className={classes.holidayIconRight}>
                    <img src={bannerData.bannerIcon} alt="holiday_banner_right" />
                </span>
            </section>
        </section>
    );
};

CalendarBanner.propTypes = {
    bannerData: object,

};

CalendarBanner.defaultProps = {
    bannerData: null,
};

export default CalendarBanner;
